// extracted by mini-css-extract-plugin
module.exports = {"topAd_box":"topAd_box-22Vi-J4A","header":"header-1LrQICwi","header_bar":"header_bar-3c1mRr9r clearfix","box":"box-2bbgMBbC","user":"user-3EeGkNUp","search":"search-33YnUDli"};